import { combineReducers } from 'redux';
import login from './login';
import user from './user';
import buildings from './buildings';
import equipment from './equipment';
import points from './points';
import devices from './devices';
import ui from './ui';
import equipTypes from './equiptypes';
import pointTypes from './pointtypes';
import tags from './tags';
import labels from './labels';
import series from './timeseries';
import attachments from './attachments';
import users from './users';
import units from './units';
import apiKeys from './apiKeys';
import ingestStats from './ingeststats';
import alerts from './alerts';
import analytics from './analytics';
import actionLog from './actionLog';
import appVariant from './variant';
import rtemFiles from './rtemFiles';
import rtemSubmissions from './rtemSubmissions';
import measurements from './measurements';
import notificationPreferences from './notificationPreferences';
import dataRequests from './dataRequests';
import unitPrefs from './unitPrefs';
import deployments from './deployments';
import staging from './staging';
import tsExports from './exports';
import dataAlerts from './dataAlerts';
import modbus from './modbus';

const entities = combineReducers({
  buildings,
  equipment,
  equipTypes,
  points,
  pointTypes,
  devices,
  tags,
  labels,
  series,
  attachments,
  units,
  ingestStats,
  alerts,
  measurements,
  notificationPreferences,
  dataRequests,
  unitPrefs,
  deployments,
  staging,
  tsExports,
  dataAlerts,
  modbus,
});

// the root reducer- essentially the state tree for the entire app
const rootReducer = combineReducers({
  login,
  user,
  entities,
  ui,
  users,
  apiKeys,
  analytics,
  actionLog,
  rtemFiles,
  rtemSubmissions,
  appVariant,
});

export default rootReducer;
